import { render, staticRenderFns } from "./RelockTokenDialog.vue?vue&type=template&id=7ddca4fd&"
import script from "./RelockTokenDialog.vue?vue&type=script&lang=js&"
export * from "./RelockTokenDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports